/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Upload_No_Personal_SpaceInputs */



/**
* | output |
* | --- |
* | "You need a personal space to upload files." |
*
* @param {Chat_Upload_No_Personal_SpaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_upload_no_personal_space = /** @type {((inputs?: Chat_Upload_No_Personal_SpaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Upload_No_Personal_SpaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Du brauchst einen persönlichen Space, um Dateien hochzuladen.")
	return /** @type {LocalizedString} */ ("You need a personal space to upload files.")
});